<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>评价系统</el-breadcrumb-item>
      <el-breadcrumb-item>评委管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-page-header @back="goBack"></el-page-header>

    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span>评委信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="70px"
        ref="queryFormRef"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
                @keyup.enter.native="getDataList('search')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18" align="right">
            <el-button type="primary" @click="getDataList('search')">查询</el-button>
            <el-button type="primary" plain @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span>评委列表</span>
        </el-col>
        <el-col :span="12" align="right">
          <el-button type="primary" plain size="small" @click="handleAdd">新增评委</el-button>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="#" type="index" width="60"></el-table-column>
        <el-table-column label="头像" width="100">
          <template slot-scope="scope">
            <el-image v-if="scope.row.avatar"
              style="width: 60px; height: 60px"
              :src="scope.row.avatar"
              :preview-src-list="[scope.row.avatar]">
            </el-image>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="性别" prop="sex" :formatter="sexFormat"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="邮箱" prop="email" show-overflow-tooltip></el-table-column>
        <el-table-column label="微信号" prop="wechatNo"></el-table-column>
        <el-table-column label="简介" prop="introduction" show-overflow-tooltip></el-table-column>
        <el-table-column label="点评链接">
          <template slot-scope="scope">
            <div>
            {{ url + scope.row.code }}
            </div>
            <el-button type="primary" size="mini" @click="copyFn(scope.row.code)" plain>复制链接</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editFn(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 15px"
      >
      </el-pagination>
    </el-card>

    <!-- 新增/编辑dialog -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addDialogVisible"
      width="600px"
      @close="addDialogClosed"
    >
      <el-form :model="addForm" label-width="80px" ref="addFormRef" :rules="addRules">
        <el-form-item label="头像" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :action="uploadObj.uploadUrl"
            accept="image/*"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :headers="uploadObj.headerObj"
            :before-upload="beforeUpload"
            :data="{
              filePath: 'spbcnWeb/pbl/upload/avatar/',
            }"
          >
            <img
              v-if="addForm.avatar"
              class="img-detail"
              :src="addForm.avatar"
            />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="addForm.userName" placeholder="请输入" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="addForm.sex">
            <el-radio :label="1">女</el-radio>
            <el-radio :label="2">男</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="addForm.phone" placeholder="请输入" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="addForm.email" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="微信号" prop="wechatNo">
          <el-input v-model="addForm.wechatNo" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="introduction">
          <el-input
            type="textarea"
            :rows="4"
            v-model="addForm.introduction"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="handleAddSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPblJudgePage, pblJudgeCreate, pblJudgeEdit, pblJudgeDel } from '@/http/api'

export default {
  data () {
    return {
      url: 'https://ghacedu.spbcn.org/#/reviewPage?code=',
      total: 0,
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        userName: ''
      },
      dataList: [],
      addDialogVisible: false,
      addLoading: false,
      // 编辑时的主键 id，null 表示当前是新增
      editId: null,
      addForm: {
        avatar: '',
        userName: '',
        sex: 1,
        phone: '',
        email: '',
        wechatNo: '',
        introduction: ''
      },
      addRules: {
        userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ]
      },
      uploadObj: {
        uploadUrl: this.$env.baseIP + 'upload/uploadFileAliOss',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.editId !== null && this.editId !== undefined ? '编辑评委' : '新增评委'
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取列表数据
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getPblJudgePage(this.queryForm).then((res) => {
        console.log('getPblJudgePage', res)
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 新增按钮点击事件
    handleAdd () {
      this.editId = null
      this.addDialogVisible = true
    },
    // 编辑按钮点击事件：回填该行数据，复用新增弹窗
    editFn (row) {
      this.editId = row.id
      this.addForm = {
        avatar: row.avatar || '',
        userName: row.userName || '',
        // 后端可能返回字符串 '1'/'2'，统一转成数字给 radio 用
        sex: Number(row.sex) === 2 ? 2 : 1,
        phone: row.phone || '',
        email: row.email || '',
        wechatNo: row.wechatNo || '',
        introduction: row.introduction || ''
      }
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addFormRef.clearValidate()
      })
    },
    // 删除按钮点击事件
    delFn (row) {
      this.$confirm('此操作将永久删除该评委, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return pblJudgeDel({ id: row.id })
      }).then((res) => {
        if (res && res.code === 200) {
          this.$message.success('删除成功')
          this.getDataList()
        } else {
          this.$message.error((res && res.msg) || '删除失败')
        }
      }).catch((err) => {
        // 用户取消弹窗（cancel / close）不当作异常处理
        if (err === 'cancel' || err === 'close') return
        console.log('err', err)
      })
    },
    // 新增弹窗关闭事件
    addDialogClosed () {
      this.editId = null
      this.addForm = {
        avatar: '',
        userName: '',
        sex: 1,
        phone: '',
        email: '',
        wechatNo: '',
        introduction: ''
      }
      this.$refs.addFormRef.clearValidate()
    },
    // 提交新增/编辑
    handleAddSubmit () {
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return
        // 先取出来：关弹窗会触发 addDialogClosed 把 editId 置空
        const editId = this.editId
        const isEdit = editId !== null && editId !== undefined
        const params = isEdit ? { ...this.addForm, id: editId } : { ...this.addForm }
        this.addLoading = true
        const requestApi = isEdit ? pblJudgeEdit : pblJudgeCreate
        requestApi(params).then((res) => {
          if (res.code === 200) {
            this.$message.success(isEdit ? '编辑成功' : '新增成功')
            this.addDialogVisible = false
            // 编辑停留在当前页，新增回第一页看新数据
            this.getDataList(isEdit ? undefined : 'search')
          }
          this.addLoading = false
        }).catch(() => {
          this.addLoading = false
        })
      })
    },
    // 重置
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList('search')
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    sexFormat (data) {
      return data.sex === 1 || data.sex === '1' ? '女' : data.sex === 2 || data.sex === '2' ? '男' : '--'
    },
    beforeUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isLt5M
    },
    uploadSuccess (res) {
      this.$set(this.addForm, 'avatar', res.data)
    },
    copyFn (code) {
      const url = this.url + code
      var input = document.createElement('input') // 创建input标签
      input.value = url
      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    }
  }
}
</script>

<style lang="less" scoped>
.img-detail{
  max-width: 100px;
  max-height: 100px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
}
.avatar-uploader-icon:hover {
  border-color: #409eff;
}
.dialog-footer{
  text-align: center;
}
</style>
